<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
    list-style: none;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: scroll;
}
html,body {
    height: 100%;
  }

*el-button {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>
